// libs
import React, { memo } from 'react';

// components
import ToastWrapper from 'shared/components/Toast';
import Toast from 'shared/components/Boot/components/SuccessLoginToast';
import StoreSwitchToast from 'shared/components/StoreSwitchToast';

interface AppProviderProps {
  children: React.ReactNode;
}

function AppProvider({ children }: AppProviderProps) {
  return (
    <ToastWrapper>
      {children}
      <Toast />
      <StoreSwitchToast />
    </ToastWrapper>
  );
}

export default memo(AppProvider);
